import { render, staticRenderFns } from "./TdAddOrg.vue?vue&type=template&id=a8ba9b8e&scoped=true&"
import script from "./TdAddOrg.vue?vue&type=script&lang=js&"
export * from "./TdAddOrg.vue?vue&type=script&lang=js&"
import style0 from "./TdAddOrg.vue?vue&type=style&index=0&id=a8ba9b8e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8ba9b8e",
  null
  
)

export default component.exports